import {defineStore} from "pinia";
import {computed, ref} from "vue";
import {LanguageModel} from "@/shared";
import Cookies from "js-cookie";
import LocalizationModel from "./models/LocalizationModel";

export const useLocalizationStore = defineStore("localizationStore", () => {
  const isInited = ref(false);
  // const api = ref<apiDataSource>();
  const CurrentCulture = ref("ENG");
  const CultureCookieName = ref("culture");

  const localization = ref<Array<LocalizationModel>>(new Array<LocalizationModel>());
  const init = async () => {
    let arrLoc = await fetch("/localization.json").then(async (res) => {
      return await res.text().then((result) => {
        return JSON.parse(result);
      });
    });
    if (!!arrLoc) {
      for (let key in arrLoc) {
        localization.value.push(new LocalizationModel({
          Key: key,
          Values: arrLoc[key],
        }));
      }
      isInited.value = true;
    }
  };
  const translate = (key: string) => {
    if (!isInited.value || !key) return key;
    return localization.value?.find(_ => _.Key == key)?.Values.find(el => el.LangCode == getCurrentCulture.value.Key)?.Value ?? key;
  };
  /**
   * Получить список разрешаемых языков на сайте
   * @returns
   */
  const getAllLang = computed((): Array<LanguageModel> => {
    return [{Key: "ENG", Value: "EN"}, {Key: "FRA", Value: "FR"}, {Key: "RUS", Value: "RU"}];
  });

  /**
   * Текущая локализация
   * @returns
   */
  const getCurrentCulture = computed((): LanguageModel => {
    let culture = Cookies.get(CultureCookieName.value);
    if (!culture) culture = "ENG";
    if (culture && CurrentCulture.value != culture) {
      if (culture != "ENG") {
        setCurrentCulture("ENG");
        CurrentCulture.value = "ENG";
      } else {
        CurrentCulture.value = culture;
      }
    }
    return getAllLang.value.find(_ => _.Key == CurrentCulture.value);
  });
  const setCurrentCulture = (culture: string) => {
    Cookies.set(CultureCookieName.value, culture, {
      expires: new Date(new Date().getTime() + 30 * 24 * 60 * 60 * 1000),
    });
    CurrentCulture.value = culture;
  };
  const getLocal = () => {
    CurrentCulture.value = Cookies.get(CultureCookieName.value);
  };

  return {
    isInited,
    getCurrentCulture,
    getAllLang,
    init,
    translate,
    setCurrentCulture,
    getLocal,
  };
});
